"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgentUtilities = void 0;
const WATCHER_INDICATOR = '-watcher';
class AgentUtilities {
    /**
     * Generates and returns clientId that is used for the IoT device representing agent
     * @param agentId agnet id
     * @param environmentId environment id
     * @returns IoT device clientId
     */
    static constructDeviceAgentId(agentId, environmentId) {
        return `${agentId}@${environmentId}`;
    }
    /**
     * Generates and returns clientId that is used for the IoT device representing watcher agent
     * @param agentId agent id
     * @param environmentId environment id
     * @returns IoT device client id
     */
    static constructDeviceAgentWatcherId(agentId, environmentId) {
        return `${this.appendWatcherIndicater(agentId)}@${this.appendWatcherIndicater(environmentId)}`;
    }
    /**
     * Generates and returns agent's watcher id
     * @param agentId agent id
     * @returns aggent's watcher id
     */
    static getWatcherAgentId(agentId) {
        return this.appendWatcherIndicater(agentId);
    }
    /**
     * Generates and returns watchers environment id
     * @param environmentId environment id
     * @returns watchers environment id
     */
    static getWatcherEnvironmentId(environmentId) {
        return this.appendWatcherIndicater(environmentId);
    }
    static appendWatcherIndicater(id) {
        return `${id}id${WATCHER_INDICATOR}`;
    }
}
exports.AgentUtilities = AgentUtilities;
